export default "__VITE_ASSET__mMwE4Ezz__"